export default __webpack_public_path__ + "static/media/giphy.41854774.gif";